/**
 * Document types whose type alone is a good signal for what to extract.
 * IDs are `DocumentTypeEnum.DocumentTypeEnumID` values.
 */
const DOCUMENT_TYPE = {
  // The backend treats both of these as fact sheets — see
  // FACT_SHEET_DOC_TYPE_IDS in DocumentProcessingStatus.provider.ts.
  PERFORMANCE: 15,
  FACT_SHEET: 135,
  DDQ: 28,
  OFFERING_MEMORANDUM: 30,
  RCG_FUND_LPA: 62,
  LPA: 93,
} as const;

const TERMS_PROMPT =
  "Extract the share class terms from the attached document — fees, liquidity, " +
  "and any private-equity liquidity terms — and stage the updates for review.";

const FIRM_AND_TEAM_PROMPT =
  "Extract the firm profile and the team members from the attached document " +
  "and stage the updates for review.";

const INVESTMENT_PROFILE_PROMPT =
  "Extract the investment profile from the attached document and stage the " +
  "updates for review.";

export const GENERIC_EXTRACT_PROMPT =
  "Extract the data from the attached document and stage the updates for review.";

/** Starter prompt per document type. Anything unlisted gets the generic one. */
const DOCUMENT_TYPE_PROMPTS: Record<number, string> = {
  [DOCUMENT_TYPE.LPA]: TERMS_PROMPT,
  [DOCUMENT_TYPE.RCG_FUND_LPA]: TERMS_PROMPT,
  [DOCUMENT_TYPE.OFFERING_MEMORANDUM]: TERMS_PROMPT,
  [DOCUMENT_TYPE.DDQ]: FIRM_AND_TEAM_PROMPT,
  [DOCUMENT_TYPE.FACT_SHEET]: INVESTMENT_PROFILE_PROMPT,
  [DOCUMENT_TYPE.PERFORMANCE]: INVESTMENT_PROFILE_PROMPT,
};

/**
 * The "Extract data in chat" starter prompt for a document of this type.
 */
export function extractInChatPrompt(
  documentTypeEnumId: number | null | undefined
): string {
  if (documentTypeEnumId == null) return GENERIC_EXTRACT_PROMPT;
  return DOCUMENT_TYPE_PROMPTS[documentTypeEnumId] ?? GENERIC_EXTRACT_PROMPT;
}
